export default "__VITE_ASSET__hYDByiLb__"